export default "__VITE_ASSET__CLOnlHnl__"